import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "pymio",
  interest_rate: 30,
  companyNames: ["Lendit Group SAPI de CV"],
  status_waiting_room: "CSEOF",
  url_waiting_room: "/producto/creditosimple/esperando_ofertas",
  home_url: "",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_tBa1HDVGi",
      userPoolClientId: "6ah7hc05bl7n6rqft7tdp7g8b3",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_76FjagSZI",
      userPoolClientId: "4hukgnioi4gqqkig3dr8slbp7k",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
